import React, { Component } from "react";
import { useEffect, useState } from "react";
import styled from 'styled-components';
import mapIcon from "../assets/mapIcon.png";
import houseIcon from "../assets/Icons/house.svg"
import peopleIcon from "../assets/Icons/people.svg"

const DormButtonWrapper = styled.div`
	display: flex;
  position: relative;
	flex-direction: column;
  justify-content: space-between;
  gap: 5px;
	cursor: pointer;
  margin-bottom: 1rem;
  width: 100%;
  height: 100%;
  padding: 1rem;
  background-color: white;
  border-radius: 10px;
  
  img{
    padding: 0px;
    border: 1px solid ${props => props.theme.lightGray};
    height: 14vw;
    width: 100%;
    border-radius: 10px;
    object-fit: cover;

    @media only screen and (max-width: 768px) {
      max-width: 100%;
      min-width: 100%;
      max-height: 25vw;
    }
  }

  .details {
    display: flex;
	  flex-direction: column;
  }
  @media only screen and (min-width: 768px) {
		// flex-direction: row;
    // margin-bottom: 0.5rem;
  }
`

const DormInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const SchoolName = styled.div`
  display: flex;
  font-size: 1rem;
  line-height: 1rem;
  text-transform: capitalize;
`

const ColumbiaName = styled(SchoolName)`
  color: ${props => props.theme.columbiaBlue};
`

const BarnardName = styled(SchoolName)`
  color: ${props => props.theme.barnardBlue};
`

const DormName = styled.div`
  font-family: Georgia;
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 1.2rem;
`

const Amenity = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.8rem;
  @media only screen and (max-width: 768px){
    display: none;
  }
`

const Amenities = styled.div`
  
`

const MapButton = styled.button`
  padding: 0.25rem;
  position: absolute;
  bottom: 20px;
  right: 20px;
  border-radius: 50%;
  z-index: 99;
  align-items: center;
  justify-content: center;
  background-color: white;
  border: none;
  cursor: pointer;
  display: none;

  @media only screen and (min-width: 768px) {
    display: flex;
  }
`;

const MapIconImg = styled.img`
  height: 40px !important;
  width: 40px !important;
  display: block;
  object-fit: contain;
  border: none !important;
`;

const Icon = styled.img`
  height: 15px !important;
  width: 15px !important;
  object-fit: contain !important;
  border: none !important;
  border-radius: 0px !important;
`;

const Description = styled.div`
  display: none;
  @media only screen and (min-width: 768px){
    display: inline;
  }
  &>p {
    font-size: 0.8rem;
  }
`;

const SeeMore = styled.h6`
  display: inline;
	cursor: pointer;
	color: ${props => props.theme.columbiaBlue};
	text-align: right;  
`;

const DormButton = props => {
  const [roomtype, setRoomType] = useState("");
  const [classMakeupFormat, setClassMakeup] = useState("");
  const [dormStyle, setDormStyle] = useState("");
  const schoolName = props.school.toLowerCase();
  const [dormName, setDormName] = useState("");

  useEffect(() => {
    if (props.class_makeup) 
      setClassMakeup(props.class_makeup.split(",").map((el, i) => el.charAt(0).toUpperCase() + el.slice(1)).join(", "));
    
    if (props.BUILDING_TYPE_ === 2) setDormStyle("Apartment-Style");
    else if (props.BUILDING_TYPE_ === 1) setDormStyle("Suite-Style");
    else setDormStyle("Corridor-Style");

    setRoomTypeString();

    if (props.name === "548 W 113th"){
      setDormName("548 W 113th (Symposium)");
    } else if (props.name === "600 W 113th"){
      setDormName("600 W 113th (Nuss)");
    } else {
      setDormName(props.name);
    }

  }, [props.BUILDING_TYPE_, props.name]);

  const setRoomTypeString = () => {
    var roomtype = "";
    
    if (props.WALKTHROUGH){
      roomtype += "Doubles and walkthrough doubles";
    } else {
      if (props.SINGLE_ && props.DOUBLE_ && props.TRIPLE_){
        roomtype += " Singles, doubles, and triples";
      } else if (props.SINGLE_ && props.DOUBLE_){
        roomtype += " Singles and doubles";
      } else {
        if (props.SINGLE_) roomtype += "Singles";
        if (props.DOUBLE_) roomtype += "Doubles";
        if (props.TRIPLE_) roomtype += " and triples";
      }
    }

    setRoomType(roomtype);
  }
    
  return (
    <DormButtonWrapper>
      <DormInfoWrapper>
        {schoolName == "columbia" ? 
          <ColumbiaName> { schoolName } </ColumbiaName>
        : (schoolName == "barnard" ?
          <BarnardName> { schoolName } </BarnardName>
        :
          <SchoolName> { schoolName } </SchoolName>
          )
        }
        <DormName> {dormName} </DormName>
        <div className="details">
          <Amenities> 
            <Amenity><Icon src={houseIcon} /> {dormStyle} | {roomtype}</Amenity>
            <Amenity><Icon src={peopleIcon} /> {classMakeupFormat}</Amenity>
          </Amenities>
        </div>
      </DormInfoWrapper>
      <img className="dormimage" src={props.image} />
      <MapButton
        type="button"
        onClick={event => {
          event.preventDefault();
          event.stopPropagation();
          props.onMapClick();
        }}
        aria-label={`Show map for ${props.name}`}
      >
        <MapIconImg src={mapIcon} />
      </MapButton>
    </DormButtonWrapper>
  );

}

export default DormButton;
